import { v4 as uuidv4 } from 'uuid';
export var patientSelfServiceLinksArray = [{
  id: uuidv4(),
  href: '/account/',
  linkName: 'sharp-account',
  anchorName: 'Sharp Account',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/patient/billing/',
  linkName: 'pay-my-bill',
  anchorName: 'Pay My Bill',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/patient/billing/request-a-hospital-price-estimate.cfm',
  linkName: 'request-a-hospital-price-estimate',
  anchorName: 'Request a Hospital Price Estimate',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/get-care/',
  linkName: 'get-care-today',
  anchorName: 'Get Care Today',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/patient/followmyhealth/',
  linkName: 'follow-my-health',
  anchorName: 'FollowMyHealth',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/patient/medical-records.cfm',
  linkName: 'medical-records',
  anchorName: 'Medical Records',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/patient/appointments.cfm',
  linkName: 'appointments',
  anchorName: 'Appointments',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/san-diego-doctors/',
  linkName: 'find-san-diego-doctors',
  anchorName: 'Find San Diego Doctors',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/health-classes/',
  linkName: 'health-classes-in-san-diego',
  anchorName: 'Health Classes in San Diego',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/locations/',
  linkName: 'maps-and-directions',
  anchorName: 'Maps and Directions',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/patient/newsletters.cfm',
  linkName: 'newsletter',
  anchorName: 'Email Newsletters',
  target: '_self'
}];
export var hospitalsAndMedicalGroupsArray = [{
  id: uuidv4(),
  href: '/hospitals/chula-vista/',
  linkName: 'sharp-chula-vista',
  anchorName: 'Sharp Chula Vista Medical Center',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/hospitals/coronado/',
  linkName: 'sharp-coronado',
  anchorName: 'Sharp Coronado Hospital',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/hospitals/grossmont/',
  linkName: 'sharp-grossmont',
  anchorName: 'Sharp Grossmont Hospital',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/hospitals/mary-birch/',
  linkName: 'sharp-mary-birch',
  anchorName: 'Sharp Mary Birch Hospital for Women & Newborns',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/hospitals/mcdonald/',
  linkName: 'sharp-mcdonald',
  anchorName: 'Sharp McDonald Center',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/hospitals/memorial/',
  linkName: 'sharp-memorial',
  anchorName: 'Sharp Memorial Hospital',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/hospitals/mesa-vista/',
  linkName: 'sharp-mesa-vista',
  anchorName: 'Sharp Mesa Vista Hospital',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/sharpcare/',
  linkName: 'sharp-sharpcare',
  anchorName: 'SharpCare Medical Group',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/sharp-community/',
  linkName: 'sharp-community',
  anchorName: 'Sharp Community Medical Group',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/rees-stealy/',
  linkName: 'sharp-rees-stealy',
  anchorName: 'Sharp Rees-Stealy Medical Group',
  target: '_self'
}];
export var employeesAndPartnersArray = [{
  id: uuidv4(),
  href: '/employees/',
  linkName: 'employees',
  anchorName: 'For Employees',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/physicians/',
  linkName: 'physicians',
  anchorName: 'For Physicians',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/interns-fellows/',
  linkName: 'interns-fellows',
  anchorName: 'For Interns and Fellows',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/instructors-students/',
  linkName: 'instructors-students',
  anchorName: 'For Instructors and Students',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/instructors-students/',
  linkName: 'instructors-students',
  anchorName: 'For Instructors and Students',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/media-center/',
  linkName: 'media',
  anchorName: 'For Media',
  target: '_self'
}, {
  id: uuidv4(),
  href: '/vendors/',
  linkName: 'vendors',
  anchorName: 'For Vendors',
  target: '_self'
}];
export var companyInformationArray = [{
  id: uuidv4(),
  href: '/employees/',
  linkName: 'employees',
  anchorName: 'For Employees',
  target: '_self'
}, {
  id: uuidv4(),
  href: 'https://careers.sharp.com/',
  linkName: 'jobs',
  anchorName: 'Jobs',
  target: '_blank'
}, {
  id: uuidv4(),
  href: '/volunteer/',
  linkName: 'volunteer',
  anchorName: 'Volunteer Opportunities',
  target: '_self'
}, {
  id: uuidv4(),
  href: '//give.sharp.com/',
  linkName: 'donate',
  anchorName: 'Donate to Sharp / Foundations',
  target: '_blank'
}, {
  id: uuidv4(),
  href: 'https://www.sharphealthplan.com/',
  linkName: 'health-insurance',
  anchorName: 'Sharp Health Plan',
  target: '_blank'
}, {
  id: uuidv4(),
  href: '/patient-rights-privacy/',
  linkName: 'patient-rights-privacy',
  anchorName: 'Patient Rights and Privacy',
  target: '_self'
}];